import type { StepProps } from './types';

type Props = Pick<StepProps, 'formData' | 'onChange' | 'onNext' | 'onBack'>;

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '12px 14px',
  border: '1.5px solid #e2e8f0',
  borderRadius: '8px',
  fontSize: '15px',
  fontFamily: "'Zen Maru Gothic', sans-serif",
  outline: 'none',
  color: '#333',
};

const backBtnStyle: React.CSSProperties = {
  background: 'transparent',
  border: 'none',
  color: '#bbb',
  fontSize: '12px',
  cursor: 'pointer',
  padding: '4px 8px',
  textDecoration: 'underline',
};

// 生年月日プルダウンの選択肢（看護師の就業年齢帯を余裕をもってカバーする範囲）
const CURRENT_YEAR = new Date().getFullYear();
const BIRTH_YEARS = Array.from({ length: 60 }, (_, i) => String(CURRENT_YEAR - 18 - i));
const MONTHS = Array.from({ length: 12 }, (_, i) => String(i + 1));
const DAYS = Array.from({ length: 31 }, (_, i) => String(i + 1));

export default function StepAddressName({ formData, onChange, onNext, onBack }: Props) {
  const canNext =
    formData.nearestStation.trim().length > 0 &&
    formData.lastName.trim().length > 0 &&
    formData.firstName.trim().length > 0 &&
    formData.birthYear !== '' &&
    formData.birthMonth !== '' &&
    formData.birthDay !== '';

  const handleNext = () => {
    if (!canNext) return;
    onNext();
  };

  return (
    <div>
      <p style={{ fontWeight: 700, fontSize: '15px', marginBottom: '14px', color: '#333' }}>
        Q4. 最寄り駅・お名前・生年月日を入力してください
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '20px' }}>
        {/* 最寄り駅 */}
        <div>
          <label style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '6px', fontWeight: 600 }}>
            お住まい・ご希望勤務地の最寄り駅
          </label>
          <input
            style={inputStyle}
            placeholder="例：新宿駅"
            value={formData.nearestStation}
            onChange={(e) => onChange('nearestStation', e.target.value)}
          />
          <p style={{ fontSize: '11px', color: '#aaa', marginTop: '4px' }}>
            条件に沿った求人をご紹介するために利用します
          </p>
        </div>

        {/* お名前 */}
        <div>
          <label style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '6px', fontWeight: 600 }}>
            お名前
          </label>
          <div style={{ display: 'flex', gap: '10px' }}>
            <input
              style={inputStyle}
              placeholder="姓：山田"
              value={formData.lastName}
              onChange={(e) => onChange('lastName', e.target.value)}
            />
            <input
              style={inputStyle}
              placeholder="名：花子"
              value={formData.firstName}
              onChange={(e) => onChange('firstName', e.target.value)}
            />
          </div>
        </div>

        {/* 生年月日 */}
        <div>
          <label style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '6px', fontWeight: 600 }}>
            生年月日
          </label>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <select
              style={{ ...inputStyle, flex: '1.4' }}
              value={formData.birthYear}
              onChange={(e) => onChange('birthYear', e.target.value)}
            >
              <option value="">年</option>
              {BIRTH_YEARS.map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
            <span style={{ fontSize: '13px', color: '#666' }}>年</span>
            <select
              style={{ ...inputStyle, flex: '1' }}
              value={formData.birthMonth}
              onChange={(e) => onChange('birthMonth', e.target.value)}
            >
              <option value="">月</option>
              {MONTHS.map((m) => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>
            <span style={{ fontSize: '13px', color: '#666' }}>月</span>
            <select
              style={{ ...inputStyle, flex: '1' }}
              value={formData.birthDay}
              onChange={(e) => onChange('birthDay', e.target.value)}
            >
              <option value="">日</option>
              {DAYS.map((d) => (
                <option key={d} value={d}>{d}</option>
              ))}
            </select>
            <span style={{ fontSize: '13px', color: '#666' }}>日</span>
          </div>
          <p style={{ fontSize: '11px', color: '#aaa', marginTop: '4px' }}>
            年齢条件のある求人をご案内するために利用します
          </p>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: '11px', color: '#ff5c73', marginBottom: '6px', fontWeight: 700 }}>完全無料！</p>
          <button
            className="btn-next"
            style={{ padding: '15px 24px', fontSize: '15px', minWidth: '200px' }}
            onClick={handleNext}
            disabled={!canNext}
          >
            次のステップへ
          </button>
        </div>
        <button style={backBtnStyle} onClick={onBack}>
          ← 前の質問に戻る
        </button>
      </div>
    </div>
  );
}
